/* Liebreiz navigation v1, local candidate 2026-10-04.
 * Event-only companion. Uses ONLY existing gtag/dataLayer; no base/config/js,
 * consent writes, ecommerce/conversions, transport, URL/title mutation or replay.
 * Shopify native page_view metadata establishes enqueue order, NOT delivery.
 */
(function (scope, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (scope && scope.document && !scope.LRZNavigationV1) scope.LRZNavigationV1 = api.install(scope);
})(typeof window === 'object' ? window : null, function () {
  'use strict';
  const SHOP_MID = 'G-Q96X0YP2JW', BRIDAL_MID = 'G-D51KMJTDQM';
  const SHOP_HOSTS = new Set(['liebreiz-shop.de', 'www.liebreiz-shop.de']);
  const BRIDAL_HOST = 'www.liebreiz-brautmode.de';
  const INSTALL_KEY = '__lrzNavigationV1';
  const MAX_NATIVE_SCAN = 5000;
  const LANDINGS = new Set(['sortiment', 'preisbrecher', 'exklusiv-natur', 'classic-six', 'classic-lab']);
  const ROUTES = Object.freeze({
    home: ['home', 'Startseite'], wedding: ['wedding', 'Wedding'], braut: ['bridal', 'Brautmode'],
    maennersache: ['menswear', 'Männersache'], trauringe: ['wedding_rings', 'Trauringe'],
    memoire: ['memoire', 'Memoire-Ringe'], schmuck: ['jewelry', 'Schmuck'],
    sortiment: ['engagement_rings', 'Verlobungsringe'], preisbrecher: ['engagement_rings', 'Filigran'],
    'exklusiv-natur': ['engagement_rings', 'Luxury Solitaire'],
    'classic-six': ['engagement_rings', 'Classic Six'], 'classic-lab': ['engagement_rings', 'Classic LAB']
  });
  function nativePageView(entry) {
    try {
      // Frozen Google & YouTube app contract; read ONLY these four metadata fields.
      if (!Array.isArray(entry) && Object.prototype.toString.call(entry) !== '[object Arguments]') return false;
      if (entry[0] !== 'event' || entry[1] !== 'page_view') return false;
      const p = entry[2];
      return !!p && typeof p === 'object' && p.send_to === SHOP_MID && p.shopify_event_name === 'page_viewed';
    } catch (_) { return false; }
  }
  function consentCookie(text, name) {
    let found = null;
    for (const row of String(text || '').split(';')) {
      const trimmed = row.trim(); if (!trimmed.startsWith(name + '=')) continue;
      let value; try { value = decodeURIComponent(trimmed.slice(name.length + 1)); } catch (_) { return null; }
      if (found !== null && found !== value) return null;
      found = value;
    }
    return found;
  }
  function bridalAnalytics(document) {
    try {
      const text = document.cookie;
      return consentCookie(text, 'lrz_consent_v4') === '4.0' &&
        ['statistics', 'all'].includes(consentCookie(text, 'lrz_consent_choice'));
    } catch (_) { return false; }
  }
  function merchantTitle(text) {
    // ONLY the dedicated merchant heading, never forms, aria-labels or URL text.
    if (typeof text !== 'string') return 'Produktdetails';
    const clean = text.trim().replace(/\s+/g, ' ');
    if (!clean || clean.length > 100 || /[\r\n@<>]|https?:|www\.|\d{6,}|\b(?:token|email|e-mail|telefon|password|session)\b/i.test(text) ||
        !/^[\p{L}\p{N} .,:;()'’"&/+·–—-]+$/u.test(clean)) return 'Produktdetails';
    return clean;
  }
  function section(root) {
    const route = root && root.dataset && root.dataset.lwsEntryRoute;
    if (!Object.prototype.hasOwnProperty.call(ROUTES, route)) return null;
    const [name, title] = ROUTES[route];
    return { shop_section: name, shop_landing: LANDINGS.has(route) ? route : 'none', title };
  }
  function navigation(scope, site, event) {
    if (!event || event.isTrusted !== true || !event.target || typeof event.target.closest !== 'function') return null;
    if (event.type === 'click' ? event.button !== 0 : event.type !== 'auxclick' || event.button !== 1) return null;
    const selector = site === 'shop' ? '[data-lws-release] .lr-nav a.lws-entry-localstore' : '#menu-item-12844 a, #av-burger-menu-ul li.menu-item-12844 a';
    const link = event.target.closest(selector);
    if (!link || link.hasAttribute('download')) return null;
    try {
      const url = new URL(link.getAttribute('href'), scope.location.href);
      if (url.protocol !== 'https:' || url.port || url.username || url.password || url.pathname !== '/' || url.search || url.hash) return null;
      if (site === 'shop' ? url.hostname !== BRIDAL_HOST : !SHOP_HOSTS.has(url.hostname)) return null;
      return { navigation_direction: site === 'shop' ? 'shop_to_bridal' : 'bridal_to_shop',
        navigation_source: site === 'shop' ? 'shop' : 'bridal',
        navigation_destination: site === 'shop' ? 'bridal' : 'shop', navigation_placement: 'mainnav' };
    } catch (_) { return null; }
  }
  function install(scope) {
    if (scope[INSTALL_KEY]) return scope[INSTALL_KEY];
    if (!scope.document || !scope.location || scope.location.protocol !== 'https:') return { installed: false, reason: 'unsupported-origin' };
    const site = SHOP_HOSTS.has(scope.location.hostname) ? 'shop' : scope.location.hostname === BRIDAL_HOST ? 'bridal' : null;
    if (!site) return { installed: false, reason: 'unsupported-origin' };
    const document = scope.document, mid = site === 'shop' ? SHOP_MID : BRIDAL_MID;
    const start = Date.now();
    let nativeSeen = false, nativeLayer = null, stopped = false, hidden = false, epoch = 0, count = 0;
    let initialBlocked = false, sectionAttempted = false, dialog = null, dialogObserver = null;
    let wasOpen = false, cycleSent = false, cycleEpoch = -1;
    function root() { return document.querySelector('[data-lws-release]'); }
    function analytics() {
      if (site === 'bridal') return bridalAnalytics(document);
      try {
        const privacy = scope.Shopify && scope.Shopify.customerPrivacy;
        return !!privacy && typeof privacy.currentVisitorConsent === 'function' &&
          typeof privacy.analyticsProcessingAllowed === 'function' && privacy.currentVisitorConsent().analytics === 'yes' &&
          privacy.analyticsProcessingAllowed() === true;
      } catch (_) { return false; }
    }
    function nativeGate() {
      if (site !== 'shop') return true;
      const layer = scope.dataLayer; if (!Array.isArray(layer)) return false;
      if (nativeLayer && nativeLayer !== layer) return false;
      if (!nativeLayer) nativeLayer = layer;
      if (nativeSeen) return true;
      for (let i = 0, end = Math.min(layer.length, MAX_NATIVE_SCAN); i < end; i++) {
        if (nativePageView(layer[i])) { nativeSeen = true; break; }
      }
      return nativeSeen;
    }
    function ready() {
      return !stopped && !hidden && document.visibilityState !== 'hidden' && analytics() &&
        Array.isArray(scope.dataLayer) && typeof scope.gtag === 'function' && nativeGate();
    }
    function pageLocation() {
      // Page paths are potentially user-generated on arbitrary Shopify pages.
      // This companion only instruments the verified / SPA; never sends searches,
      // account/order/checkout paths, full query/fragment, referrer or UTMs.
      return site === 'shop' && scope.location.pathname === '/' ? scope.location.origin + '/' : undefined;
    }
    function send(name, payload) {
      if (!ready()) return false;
      const location = site === 'shop' ? pageLocation() : 'https://' + BRIDAL_HOST + '/';
      if (!location) return false;
      try {
        scope.gtag('event', name, Object.assign({ send_to: mid, page_location: location, page_referrer: '',
          page_title: site === 'shop' ? 'Liebreiz Shop' : 'Liebreiz Brautmode' }, payload));
        count++; return true;
      } catch (_) { return false; }
    }
    function nav(event) {
      const payload = navigation(scope, site, event);
      if (payload) send('site_navigation', payload);
      // Never preventDefault, stop propagation, change href/target or wait.
    }
    function consentDecision() {
      epoch++; initialBlocked = true; cycleSent = false;
      // MutationObserver delivery is asynchronous. A no→yes decision between
      // actual open and callback must baseline that old open, never replay it.
      wasOpen = !!(dialog && dialog.open);
    }
    function userAction(event) {
      if (event.target && typeof event.target.closest === 'function' && event.target.closest('[data-lws-release]')) initialBlocked = true;
    }
    function initialSection() {
      if (site !== 'shop' || sectionAttempted || initialBlocked || hidden || Date.now() - start > 15000) return;
      const current = root();
      if (!current || current.dataset.lwsEntryReady !== 'true') return;
      // One fresh render opportunity. Failure at this instant is final: NEVER
      // retry on later SDK/native readiness/consent, and never send a base PV.
      sectionAttempted = true;
      const view = section(current);
      if (view && !(dialog && dialog.open)) send('shop_section_view', {
        shop_section: view.shop_section, shop_landing: view.shop_landing,
        page_title: view.title + ' · Liebreiz Shop', content_group: view.shop_section
      });
    }
    function transition() {
      if (!dialog || stopped) return;
      const opened = dialog.open === true;
      if (opened === wasOpen) return;
      wasOpen = opened;
      const view = section(root());
      if (opened) {
        cycleSent = false; cycleEpoch = epoch; initialBlocked = true;
        if (!view) return;
        const heading = dialog.querySelector('[data-lr-detail-title]');
        cycleSent = send('page_view', {
          page_title: 'Produkt · ' + merchantTitle(heading && heading.textContent),
          content_group: view.shop_section, shop_section: view.shop_section,
          shop_landing: view.shop_landing, shop_view: 'product_open'
        });
      } else {
        const allowed = cycleSent && cycleEpoch === epoch; cycleSent = false;
        if (allowed && view) send('page_view', {
          page_title: view.title + ' · Liebreiz Shop', content_group: view.shop_section,
          shop_section: view.shop_section, shop_landing: view.shop_landing, shop_view: 'product_close'
        });
      }
    }
    function sync() {
      if (site !== 'shop' || stopped) return;
      const next = document.querySelector('[data-lws-release] [data-lr-product]');
      if (next !== dialog) {
        if (dialogObserver) dialogObserver.disconnect();
        dialog = next; wasOpen = !!(dialog && dialog.open); cycleSent = false;
        // An already-open popup at discovery is NOT a fresh open and isn't replayed.
        if (dialog && typeof scope.MutationObserver === 'function') {
          dialogObserver = new scope.MutationObserver(transition);
          dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
        }
      }
      initialSection();
    }
    function pagehide() { hidden = true; epoch++; initialBlocked = true; cycleSent = false; }
    function pageshow() { hidden = false; wasOpen = !!(dialog && dialog.open); cycleSent = false; }
    let treeObserver = null;
    document.addEventListener('click', nav, true); document.addEventListener('auxclick', nav, true);
    document.addEventListener('visitorConsentCollected', consentDecision, true);
    for (const name of ['pointerdown', 'click', 'auxclick', 'input', 'change']) document.addEventListener(name, userAction, true);
    scope.addEventListener('pagehide', pagehide, true); scope.addEventListener('pageshow', pageshow, true);
    document.addEventListener('DOMContentLoaded', sync, { once: true });
    if (site === 'shop' && typeof scope.MutationObserver === 'function') {
      treeObserver = new scope.MutationObserver(sync);
      treeObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true,
        attributeFilter: ['data-lws-entry-ready', 'data-lws-entry-route'] });
    }
    sync();
    const handle = { installed: true, version: '1.0.0', site,
      health: () => ({ nativePageViewMetadataSeen: nativeSeen, queuedEvents: count, initialSectionAttempted: sectionAttempted }),
      stop() {
        if (stopped) return; stopped = true; epoch++; cycleSent = false;
        if (treeObserver) treeObserver.disconnect(); if (dialogObserver) dialogObserver.disconnect();
        document.removeEventListener('click', nav, true); document.removeEventListener('auxclick', nav, true);
        document.removeEventListener('visitorConsentCollected', consentDecision, true);
        for (const name of ['pointerdown', 'click', 'auxclick', 'input', 'change']) document.removeEventListener(name, userAction, true);
        document.removeEventListener('DOMContentLoaded', sync);
        scope.removeEventListener('pagehide', pagehide, true); scope.removeEventListener('pageshow', pageshow, true);
      }
    };
    scope[INSTALL_KEY] = handle; return handle;
  }
  return { install, nativePageView, bridalAnalytics, merchantTitle, section, navigation };
});
